import { useGetParentObjectsForCreateNewObjectLazyQuery } from 'pages/facility/api/queries/generated/GetParentObjectsForCreateNewObject';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

export const useParentObjects = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const { facilityId } = useParams();

  const [getParentObjects, { data, fetchMore, loading }] = useGetParentObjectsForCreateNewObjectLazyQuery();

  useEffect(() => {
    if (facilityId) return;

    getParentObjects({
      variables: {
        input: {
          limit: 20,
          offset: 0,
          ...(searchQuery ? { searchQuery } : {}),
        },
      },
    });
  }, [searchQuery, getParentObjects, facilityId]);

  const handleSearch = (value: string) => {
    setSearchQuery(value);
  };

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const target = e.target as HTMLDivElement;
    const isNearBottom = target.scrollHeight - target.scrollTop <= target.clientHeight + 50;

    if (isNearBottom && !loading) {
      fetchMore({
        variables: {
          input: {
            limit: 20,
            offset: data?.getParentObjectsForCreateNewObject.objects.length || 0,
            ...(searchQuery ? { searchQuery } : {}),
          },
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prev;
          return {
            getParentObjectsForCreateNewObject: {
              ...prev.getParentObjectsForCreateNewObject,
              objects: [
                ...prev.getParentObjectsForCreateNewObject.objects,
                ...fetchMoreResult.getParentObjectsForCreateNewObject.objects,
              ],
            },
          };
        },
      });
    }
  };

  return {
    parentObjects: data?.getParentObjectsForCreateNewObject.objects || [],
    handleSearch,
    handleScroll,
    loading,
  };
};
